import React from 'react'
import IconBank from '@static/images/bank.svg'
import {Tooltip} from '../../../common/Tooltip'
import {UIGameCard} from '../../../common/UIGameCard'
import {CardEnum} from '@colonist/game-states'
import {T} from '../../../common/T'
import styles from './UIGameTradeCreatorBankRatio.module.scss'
import clsx from 'clsx'
import {usePlayerValidators} from '../../../store/selectors/usePlayerValidators'
import {useGameStore} from '../../../store/GameStoreContext'
import {ModeSettingEnum} from '@colonist/game-base-types'
import {useCurrentStateValidator} from '../../../store/selectors/useCurrentStateValidator'

export interface UIGameTradeCreatorBankRatioProps {
    className?: string | undefined
    isPortraitLayout?: boolean | undefined
}

export const UIGameTradeCreatorBankRatio = ({
    className,
    isPortraitLayout,
}: UIGameTradeCreatorBankRatioProps) => {
    const {getPlayerValidator} = usePlayerValidators()
    const isBankTradeMode = useGameStore((state) => state.gameTrade.isBankTradeMode)
    const setIsBankTradeMode = useGameStore((state) => state.gameTrade.setIsBankTradeMode)
    const tradeError = useGameStore((state) => state.gameTrade.tradeError)
    const myColor = useGameStore((state) => state.myColor)
    const currentStateValidator = useCurrentStateValidator()
    const isNotMyTurn = !currentStateValidator.currentTurnPlayers.includes(myColor)
    const myPlayerValidator = getPlayerValidator(myColor)
    const myBankTradeRatioState = myPlayerValidator.bankTradeRatiosState
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P

    if(isNotMyTurn || isBeginnerMode) return null

    const tooltipContent = <div className={clsx(styles.ratioTooltipMenu, {
        [styles.portraitLayout]: isPortraitLayout,
    })}>
        {Object.entries(myBankTradeRatioState).map(([key, value]) => (
            <div key={key} className={styles.ratioItem}>
                <UIGameCard cardEnum={Number(key) as CardEnum} size='xxs' />
                <div className={styles.ratioValue}>
                    <T id="strings:colonistCommon.utils.#buffer" options={{value: `${value}:1`}} />
                </div>
            </div>
        ))}
    </div>

    const hasBankRatioError = tradeError?.payload?.hasBankTradeRatioError

    return (
        <Tooltip
            position={isPortraitLayout ? 'top' : 'right'}
            customMenuComponent={tooltipContent}
            className={clsx(styles.ratioContainer, className)}>
            <img src={IconBank} className={clsx(styles.ratioIcon, {
                [styles.active]: isBankTradeMode,
                [styles.shakingAnimation]: hasBankRatioError,
            })} onClick={() => setIsBankTradeMode(!isBankTradeMode)} />
        </Tooltip>
    )
}
